angular.module('impactx.dashboard').controller('DashboardExternalContentCtrl', [DashboardExternalContentCtrl]);

function DashboardExternalContentCtrl() {
    //no need to do anything at the moment
}
